import { application } from "./application"

// Stimulus controllers - 명시적 등록 (jsbundling에서는 eagerLoadControllersFrom 불필요)
import AlpineTreeController from "./alpine_tree_controller"
import AssigneeSelectorController from "./assignee_selector_controller"
import ContractTemplateEditorController from "./contract_template_editor_controller"
import DispatchController from "./dispatch_controller"
import GuideSidebarController from "./guide_sidebar_controller"
import HelloController from "./hello_controller"
import Layout2depthMenuController from "./layout_2depth_menu_controller"
import MakaseController from "./makase_controller"
import MakaseEffectController from "./makase_effect_controller"
import MakaseJsonFetchController from "./makase_json_fetch_controller"
import MakasePopoverController from "./makase_popover_controller"
import MakaseTabController from "./makase_tab_controller"
import MakaseTemplateController from "./makase_template_controller"
import MapClusterController from "./map_cluster_controller"
import MapCompanyController from "./map_company_controller"
import MapSearchController from "./map_search_controller"
import PetiteVueController from "./petite_vue_controller"
import SearchDatalistController from "./search_datalist_controller"
import StreamMessageController from "./stream_message_controller"
import TurbineController from "./turbine_controller"

application.register("alpine-tree", AlpineTreeController)
application.register("assignee-selector", AssigneeSelectorController)
application.register("contract-template-editor", ContractTemplateEditorController)
application.register("dispatch", DispatchController)
application.register("guide-sidebar", GuideSidebarController)
application.register("hello", HelloController)
application.register("layout-2depth-menu", Layout2depthMenuController)
application.register("makase", MakaseController)
application.register("makase-effect", MakaseEffectController)
application.register("makase-json-fetch", MakaseJsonFetchController)
application.register("makase-popover", MakasePopoverController)
application.register("makase-tab", MakaseTabController)
application.register("makase-template", MakaseTemplateController)
application.register("map-cluster", MapClusterController)
application.register("map-company", MapCompanyController)
application.register("map-search", MapSearchController)
application.register("petite-vue", PetiteVueController)
application.register("search-datalist", SearchDatalistController)
application.register("stream-message", StreamMessageController)
application.register("turbine", TurbineController)

// window globals (레거시 호환)
import {
  baseKit,
  xDataKit,
  vScopeKit,
  xScriptKit,
} from "../shared/browserKit"

window.xBaseKit = baseKit
window.xDataKit = xDataKit
window.vScopeKit = vScopeKit
window.xScriptKit = xScriptKit
